import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/student";


const new_path: string = '/faculty';

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class facultyApi extends BaseAPI {
  static getAllFaculty(query?: listType, token?: string): Promise<AxiosResponse> {
    if (!token) {
      return this.api.get(`${path}/faculty`, {
        params: { ...query },
      });
    } else {
      return this.api.get(`${path}/faculty`, {
        params: { ...query },
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }
  static getFaculty(): Promise<any> {
    return this.api.get(`/faculty`);
  }
  static postFaculty(body: any): Promise<any> {
    return this.api.post(`faculty`, body);
  }
  static patchFaculty(id: any, body: any): Promise<any> {
    return this.api.patch(`faculty/${id}`, body);
  }
  static deleteFaculty(id: any): Promise<any> {
    return this.api.delete(`faculty/${id}`);
  }










  // NEW VERSION

  static listFaculty(id_degree?: number): Promise<AxiosResponse> {
    return this.api.get(`${new_path}`, { params: { id_degree } })
  }
}
